/**
 * CvSectionHeader — Cosmic Void v1
 *
 * Shared section title for the mobile dashboard. Playfair 100 % headline,
 * optional right-side Inter link ("See all") at 60 % opacity with the
 * underline-from-left animation.
 */
import React from 'react';
import { ArrowRight } from 'lucide-react';

const CvSectionHeader = ({ title, action, onAction, testId }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      marginBottom: '14px',
      paddingRight: '4px',
    }}
    data-testid={testId}
  >
    <h3
      className="cv-font-hero"
      style={{
        fontSize: '18px',
        lineHeight: 1.2,
        color: 'var(--cv-text-active)',
        margin: 0,
        fontWeight: 600,
        letterSpacing: '-0.005em',
      }}
    >
      {title}
    </h3>
    {action && (
      <button type="button" onClick={onAction} className="cv-link" aria-label={action}>
        {action}
        <ArrowRight size={13} strokeWidth={1.5} />
      </button>
    )}
  </div>
);

export default CvSectionHeader;
